import { render, staticRenderFns } from "./MCQCreation.vue?vue&type=template&id=525ac448&scoped=true&"
import script from "./MCQCreation.vue?vue&type=script&lang=js&"
export * from "./MCQCreation.vue?vue&type=script&lang=js&"
import style0 from "./MCQCreation.vue?vue&type=style&index=0&id=525ac448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ac448",
  null
  
)

export default component.exports